<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="fmtx1"><i>For two early and outstanding teachers—Nancy Hollmann and Robert McCallum—who opened all the right doors.</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tama_9781571318879_oeb_ded_r1.vue?5c9d4e71